import {ref} from 'vue'
import {fetchMetaSeo} from "@/service";
export const useSeo = () => {
  const seo = ref(null)
  const setMeta = (value, type) => {
    return value ? {name: type, content: value} : null
  }
  const setMetaProperty = (value, type) => {
    return value ? {property: type, content: value} : null
  }
  const setLink = (value, type) => {
    return value ? {rel: type, href: value} : null
  }
  const seoContent = () => seo.value
  const setDataSeo = (response) => {
    return {
      ...(response?.meta_title && {title: response?.meta_title}),
      meta: [
        setMeta(response?.meta_description, 'description'),
        // setMeta(response?.meta_keywords, 'keywords'),
        setMetaProperty('website', 'og:type'),
        setMetaProperty(response?.meta_title_social, 'og:title'),
        setMetaProperty('TVP Info', 'og:site_name'),
        setMetaProperty(response?.url, 'og:url'),
        setMetaProperty(response?.image, 'og:image'),
        setMetaProperty(response?.meta_description, 'og:description'),
        setMeta('website', 'twitter:type'),
        setMeta(response?.meta_title_social, 'twitter:title'),
        setMeta('TVP Info', 'twitter:site_name'),
        setMeta(response?.url, 'twitter:url'),
        setMeta(response?.image, 'twitter:image'),
        setMeta(response?.meta_description, 'twitter:description'),
      ],
      link: [
        setLink(response?.url_canonical, 'canonical')
      ]
    }
  }
  const fetchAndSetMetaSeo = (params) => {
    return fetchMetaSeo(params).then(res => {
      if (res) {
        seo.value = setDataSeo(res)
      }
      return Promise.resolve(res)
    })
  }
  return {
    seoContent,
    fetchAndSetMetaSeo,
  }
}